import CardQuestPerType from "../../../../components/common/Card/CardQuestPerType";
import { useDraggableScroll, cn } from "../../../../Utils/helper";

const QuestCategorySection = ({
  title,
  quests,
  accessToken,
  isIntroCompleted,
  handleQuestClick,
  handleQuestSaved,
  isParticipantsCompleted,
  showConnectors = false,
  onEndReached,
  hasMore = true,
  isLoading = false,
}) => {
  const { scrollRef, events } = useDraggableScroll();

  // Detect near-end horizontal scroll to trigger lazy load
  const handleScroll = (e) => {
    if (!onEndReached || !hasMore || isLoading) return;
    const el = e.currentTarget;
    if (!el) return;
    if (el.scrollLeft + el.clientWidth >= el.scrollWidth - 70) {
      onEndReached();
    }
  };
  const getConsumerStatus = (quest) => {
    if (!accessToken) {
      const statusBiz = quest?.quest_business?.status_biz;
      if (statusBiz === "IN_PROGRESS" || statusBiz === "PUBLISHED")
        return "NOT_STARTED";
      if (statusBiz === "EXPIRED") return "EXPIRED";
      if (statusBiz === "COMPLETED") return "FULL";
    }
    return quest.consumer_status;
  };

  const getIsEnable = (quest) => {
    if (!accessToken) {
      const statusBiz = quest?.quest_business?.status_biz;
      return statusBiz === "IN_PROGRESS" || statusBiz === "PUBLISHED";
    }
    return quest.is_enable;
  };

  if (!quests || quests.length === 0) return null;

  return (
    <div className="flex flex-col gap-3 w-full animate-fade-in">
      <div className="text-[#A0A0A0] font-medium text-[14px]">{title}</div>

      <div
        ref={scrollRef}
        {...events}
        onScroll={handleScroll}
        className={cn(
          "flex flex-row gap-6 overflow-x-auto scrollbar-hide pb-2 px-1 cursor-grab",
          showConnectors && "quest-line-track"
        )}
        style={{ cursor: "grab" }}
      >
        {quests.map((quest) => {
          const activeParticipant = Array.isArray(quest.participants)
            ? quest.participants.find((p) => p.status === "PAUSED_QUEST")
            : null;

          return (
            <CardQuestPerType
              key={quest.id}
              quest={quest}
              questId={quest.id}
              questType={quest.quest_business.quest_type}
              rallyCoin={quest.quest_business.token}
              slotAvailable={quest.slot_available}
              consumerStatus={getConsumerStatus(quest)}
              isEnable={getIsEnable(quest)}
              isIntroCompleted={isIntroCompleted}
              expireTime={activeParticipant?.expired_at || null}
              participantId={activeParticipant?.id || null}
              isParticipantsCompleted={isParticipantsCompleted}
              onClick={() => handleQuestClick(quest)}
              onQuestSaved={handleQuestSaved}
              isClickDisabled={false}
              showConnector={true}
              reward_stickers={quest.reward_stickers}
            />
          );
        })}
      </div>
    </div>
  );
};

export default QuestCategorySection;
